import { ApocalypseFreespinWinPresentation } from "../freespin/ApocalypseFreespinWinPresentation";

export class ApocalypseFreespinBetterWinPresentation extends ApocalypseFreespinWinPresentation {
    constructor() {
        super(`ApocalypseFreespinBetterWinPresentation`);
    }
}
